// Proxy for `/home` directory
import HomePage from './home';

export default HomePage;
